import { Link } from 'react-router-dom';
import productData from '../data/productData';
import '../styles/ProductsPreview.css';

const ProductsPreview = () => {
  return (
    <section className="products-preview">
      <div className="products-preview-container">
        <header className="products-preview-header">
          <span>Built by Bularis Tech</span>
          <h2>Products &amp; Apps</h2>
          <p>Purpose-built applications that give businesses more control over important digital experiences.</p>
        </header>

        <div className="products-preview-grid">
          {productData.map((product) => (
            <article className="products-preview-card" key={product.id}>
              <span className="products-preview-type">{product.type}</span>
              <h3>{product.title}</h3>
              <p>{product.summary}</p>
              <Link to={product.path}>View app details <span aria-hidden="true">→</span></Link>
            </article>
          ))}
        </div>

        <Link to="/products" className="products-preview-link">Explore Products &amp; Apps <span aria-hidden="true">→</span></Link>
      </div>
    </section>
  );
};

export default ProductsPreview;
